import axios from 'axios'
import ActionsLogin from './LoginActions'

const config = {
  headers: {
    Authorization: 'Bearer ' + ActionsLogin.getToken()
  }
}

const listarTodos = async () => {
  let response = await axios.get(
    process.env.URL_API_BASE + '/apuracao-mensal/',
    config
  )
  return response.data
}

const listarSegmentacoes = async () => {
  let response = await axios.get(
    process.env.URL_API_BASE + '/segmentacao/',
    config
  )
  return response.data
}

const listarMotoristas = async () => {
  let response = await axios.get(
    process.env.URL_API_BASE + '/apuracao-mensal/filtro/motorista',
    config
  )
  return response.data
}

const listarMotoristasExcel = async filtro => {
  let queryString = '?sort=motorista.nome%7Casc&page=1&per_page=99999' + filtro
  let response = await axios.get(
    process.env.URL_API_BASE +
      '/apuracao-mensal/performance/listar/' +
      queryString,
    config
  )
  return response.data
}

const listarHistoricoPorMotorista = async cdMotorista => {
  let response = await axios.get(
    process.env.URL_API_BASE +
      '/apuracao-mensal/listar-por-motorista/' +
      cdMotorista,
    config
  )
  return response.data
}

const listarPorStatus = async status => {
  let response = await axios.get(
    process.env.URL_API_BASE +
      '/apuracao-mensal' +
      (status !== null && status !== undefined
        ? '/listar-por-status/' + status
        : ''),
    config
  )
  return response.data
}

export const obterPorId = async id => {
  let response = await axios.get(
    process.env.URL_API_BASE + '/apuracao-mensal/' + id,
    config
  )
  return response.data
}

const aprovar = async (id, observacao) => {
  let response = await axios.patch(
    process.env.URL_API_BASE + '/apuracao-mensal/aprovar',
    {
      cd_apuracao: id,
      observacao: observacao
    },
    config
  )
  return response.data
}

const reprovar = async (id, observacao) => {
  let response = await axios.patch(
    process.env.URL_API_BASE + '/apuracao-mensal/reprovar',
    {
      cd_apuracao: id,
      observacao: observacao
    },
    config
  )
  return response.data
}

const getUrlImagem = imgem => {
  return process.env.URL_IMG_MENSAL + '/' + imgem
}

export default {
  listarTodos,
  listarHistoricoPorMotorista,
  listarPorStatus,
  obterPorId,
  aprovar,
  reprovar,
  getUrlImagem,
  listarMotoristas,
  listarMotoristasExcel,
  listarSegmentacoes
}



// WEBPACK FOOTER //
// ./src/actions/ApuracaoMensalActions.js